import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { Link, NavLink } from 'react-router-dom';

import { StoreProvider } from '../../components';

import MessageCell from './MessageCell';

export class MessagesListView extends Component {
  render() {
    const messages = this.props.lists.messages.edges.map((e) => e.node);

    return (
      <div className="messages">
        <div className="header">
          <h2>Messages</h2>
          <div className="actions">
            <Link to="/messages/send" className="button">
              Send Message
            </Link>
            <Link to="/messages/new" className="button">
              New Message
            </Link>
          </div>
        </div>

        <div className="scroll-container">
          <div className="tabs">
            <NavLink to="/messages/tab/active" activeClassName="active">
              Active
            </NavLink>
            <NavLink to="/messages/tab/expired" activeClassName="active">
              Expired
            </NavLink>
          </div>

          <table className="tables">
            <thead>
              <tr>
                <th>Title</th>
                <th>Body</th>
                <th>End Date</th>
                <th>Type</th>
              </tr>
            </thead>
            <tbody>
              {messages.map((message) => (
                <MessageCell key={message.id} message={message} />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

const Container = createFragmentContainer(MessagesListView, {
  lists: graphql`
    fragment MessagesList_lists on Lists {
      messages(kind: $kind, first: 1000)
        @connection(key: "MessagesList_messages", filters: ["kind"]) {
        edges {
          node {
            id
            ...MessageCell_message
          }
        }
      }
    }
  `,
});

export default class MessagesList extends Component {
  render() {
    return (
      <StoreProvider
        container={Container}
        query={graphql`
          query MessagesListQuery($kind: MessageKind!) {
            lists {
              ...MessagesList_lists
            }
          }
        `}
      />
    );
  }
}
